
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Busesforcorporateevent() {



    const cardData =
    {
        keyword: 'Buses For Corporate Events',
        heading: 'Amruta Travels: Buses For Corporate Events',
        headingDescription: 'Amruta Travels offers Buses for Corporate Events, ensuring a professional, timely, and hassle-free transportation experience for your team. Whether it is an offsite meeting, conference, seminar, or group outing, our well-maintained fleet of AC and non-AC buses, including 25, 32, and 50-seater options, delivers comfort and reliability. Benefit from on-time pickups, experienced drivers, affordable rates, and round-the-clock service. Book your Corporate Event Bus with Amruta Travels and ensure a smooth and efficient travel solution tailored to your business needs!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

        "topPlaces": [
            {
                "title": "Shaniwar Wada",
                "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
            },
            {
                "title": "Aga Khan Palace",
                "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
            },
            {
                "title": "Sinhagad Fort",
                "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
            },
            {
                "title": "Osho Ashram",
                "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
            },
            {
                "title": "Khadakwasla Dam",
                "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
            },
            {
                "title": "Fergusson College Road",
                "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
            },
            {
                "title": "Lal Mahal",
                "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
            },
            {
                "title": "Pune-Okayama Friendship Garden",
                "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
            }
        ],

         "services": [
    {
      "name": "Corporate Bus Hire for Outstation",
      "description": "Amruta Travels offers reliable corporate bus hire services for outstation travel from Pune. Ideal for business tours, team-building retreats, and company conferences, our well-maintained buses ensure your employees and delegates travel comfortably and on time. We provide customized travel plans, experienced drivers, and 24/7 support for a seamless corporate journey."
    },
    {
      "name": "Corporate Bus Hire Service in Pune",
      "description": "Looking for professional and punctual transport for your company? Amruta Travels specializes in corporate bus hire services across Pune, offering flexible options tailored to your business needs. Whether it’s daily commute or special corporate events, we guarantee a smooth experience with our modern fleet and trained chauffeurs."
    },
    {
      "name": "Hire a Bus for Corporate Sector",
      "description": "Amruta Travels provides dependable and efficient bus hire solutions for the corporate sector in Pune. Our services are suitable for employee shuttles, seminars, conventions, and regular office transport. With a variety of seating capacities and AC/non-AC options, we ensure your corporate travel is convenient and cost-effective."
    },
    {
      "name": "Corporate Pick-Up and Drop Service",
      "description": "Streamline employee transportation with Amruta Travels' corporate pick-up and drop services in Pune. Our scheduled, route-optimized services are perfect for daily office travel, helping companies boost punctuality and productivity. We offer regular sanitization, GPS-tracking, and polite drivers for a safe and timely ride."
    },
    {
      "name": "AC Bus Hire for Corporate",
      "description": "Amruta Travels offers AC bus hire services for corporate clients who value comfort and class. Ideal for transporting teams to conferences, offsite meetings, or factory visits, our air-conditioned buses come with spacious seating and onboard amenities to make every journey enjoyable and professional."
    },
    {
      "name": "Affordable Corporate Bus Hire",
      "description": "Get high-quality service at a great price with Amruta Travels’ affordable corporate bus hire in Pune. Perfect for companies that need efficient employee transport without straining the budget. Choose from a range of economical options that maintain comfort, cleanliness, and professionalism."
    },
    {
      "name": "25-Seater Bus Hire for Corporate",
      "description": "Need a mid-sized transport solution for your office team? Amruta Travels offers 25-seater buses ideal for corporate group travel, meetings, and shuttles. Comfortable seating, professional drivers, and flexible schedules make it a smart choice for daily or occasional use."
    },
    {
      "name": "26-Seater Bus Hire for Corporate",
      "description": "Amruta Travels provides 26-seater buses for corporate use, perfect for transporting teams or hosting small group business travel. With AC options, ample legroom, and smooth suspension, your team will travel in comfort whether it's within Pune or to outstation destinations."
    },
    {
      "name": "32-Seater Bus Hire for Corporate",
      "description": "Our 32-seater buses are ideal for companies planning medium-sized corporate outings, offsite training sessions, or airport transfers. Amruta Travels guarantees timely pickups, courteous drivers, and a smooth experience from start to finish."
    },
    {
      "name": "50-Seater Bus Hire Corporate in Pune",
      "description": "Accommodate large corporate teams with our 50-seater bus hire service in Pune. Amruta Travels ensures bulk employee movement with ease and efficiency. Our buses are perfect for company events, factory visits, and full-day conferences."
    },
    {
      "name": "Cheap Bus Service in Pune",
      "description": "Amruta Travels offers reliable and cheap bus services for offices and organizations in Pune. Without compromising on safety or punctuality, our low-cost travel options are ideal for startups and budget-conscious firms."
    },
    {
      "name": "35-Seater Bus Hire for Corporate Events",
      "description": "Host a successful corporate event with Amruta Travels' 35-seater bus hire service. Spacious, comfortable, and well-maintained, these buses are perfect for transporting attendees between venues, hotels, or airports efficiently."
    },
    {
      "name": "Corporate Bus Service from Pune",
      "description": "For companies looking to transport teams across Maharashtra or to nearby states, Amruta Travels offers intercity corporate bus services from Pune. Plan long-distance business trips, factory tours, or multi-city travel with our professional fleet and experienced drivers."
    },
    {
      "name": "Bus Hire for Corporate Event Party",
      "description": "Planning a corporate celebration or offsite gathering? Amruta Travels offers dedicated bus hire services for corporate event parties. Ensure your guests and employees arrive safely and together, with reliable, well-maintained buses."
    },
    {
      "name": "Corporate Bus Services in Pune",
      "description": "Amruta Travels provides all-in-one corporate bus services in Pune, including daily employee commutes, airport shuttles, outstation travel, and more. We work with HR and admin teams to build efficient routes and offer consistent service quality."
    },
    {
      "name": "Private Bus Service in Pune for Office",
      "description": "Hire private buses for your company with Amruta Travels’ office transport solutions in Pune. Our fleet includes a wide variety of seating options, dedicated routes, GPS tracking, and excellent customer support to ensure your employees travel safely every day."
    }
  ],

  "tableData": [
    ["Corporate Bus Hire for Outstation", "Corporate Bus Hire Service in Pune"],
    ["Hire a Bus for Corporate Sector", "Corporate Pick-Up and Drop Service"],
    ["AC Bus Hire for Corporate", "Affordable Corporate Bus Hire"],
    ["25-Seater Bus Hire for Corporate", "26-Seater Bus Hire for Corporate"],
    ["32-Seater Bus Hire for Corporate", "50-Seater Bus Hire Corporate in Pune"],
    ["Cheap Bus Service in Pune", "35-Seater Bus Hire for Corporate Events"],
    ["Corporate Bus Service from Pune", "Bus Hire for Corporate Event Party"],
    ["Corporate Bus Services in Pune", "Private Bus Service in Pune for Office"],
    ["", ""]
  ],





      "whychoose": [
  {
    "WhyChooseheading": "Reliable Transportation for Corporate Events",
    "WhyChoosedescription": "Amruta Travels provides dependable Buses For Corporate Events, ensuring timely and efficient transportation for employees, clients, and executives. Our services are ideal for conferences, seminars, team outings, and other professional gatherings."
  },
  {
    "WhyChooseheading": "Modern and Well-Maintained Fleet",
    "WhyChoosedescription": "Our fleet includes air-conditioned, clean, and well-maintained buses equipped with comfortable seating and ample legroom, ensuring a relaxed travel experience for all corporate attendees."
  },
  {
    "WhyChooseheading": "Punctual and Professional Service",
    "WhyChoosedescription": "Time is crucial for any corporate event. Amruta Travels guarantees on-time pick-ups and drop-offs, so your team and guests arrive at the venue as scheduled, without any stress or delays."
  },
  {
    "WhyChooseheading": "Trained and Courteous Drivers",
    "WhyChoosedescription": "Our drivers are trained professionals who are punctual, courteous, and experienced in handling corporate transportation. They ensure a safe and smooth journey with a focus on professionalism and customer satisfaction."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Corporate Pricing",
    "WhyChoosedescription": "We offer competitive pricing for Buses For Corporate Events with complete transparency. No hidden costs—just clear, upfront quotes that help you stay within your company’s transportation budget."
  },
  {
    "WhyChooseheading": "Flexible Scheduling for Corporate Needs",
    "WhyChoosedescription": "Corporate events often require flexible planning. Amruta Travels offers 24/7 availability and scheduling options tailored to your event’s timing, whether it's a day-long seminar or a late-night team outing."
  },
  {
    "WhyChooseheading": "Custom Travel Solutions for Every Event",
    "WhyChoosedescription": "Every event is different. Whether it’s transporting a small team or a large group, Amruta Travels offers customizable travel plans and routes to meet your specific corporate transportation requirements."
  },
  {
    "WhyChooseheading": "Easy and Efficient Booking System",
    "WhyChoosedescription": "Booking Buses For Corporate Events with Amruta Travels is quick and convenient. Use our online booking system or connect with our customer support team to get personalized assistance and smooth coordination."
  }
]




















    }

const faqData = [
  {
    question: 'How can I book buses for a corporate event with Amruta Travels?',
    answer: 'Booking buses for your corporate event is easy with Amruta Travels. You can get in touch with us through our website, call our customer support, or email your event details. We’ll take care of the logistics so you can focus on your event.',
  },
  {
    question: 'What types of buses are available for corporate events?',
    answer: 'We offer a range of vehicles including mini-buses, 27-seater, 35-seater, and 50-seater buses. Luxury AC coaches are also available for executive-level travel. Choose based on group size and comfort preferences.',
  },
  {
    question: 'Are your buses equipped with corporate-friendly features?',
    answer: 'Yes, our buses are equipped with comfortable seating, air conditioning, ample luggage space, and options for Wi-Fi and audio systems, ensuring a pleasant travel experience for your team.',
  },
  {
    question: 'Can you manage multiple pickup and drop points for employees?',
    answer: 'Absolutely! We can organize multiple pickup and drop-off locations across the city. Share your route plan, and we’ll coordinate everything for timely transfers.',
  },
  {
    question: 'Do you offer transportation for outstation corporate events?',
    answer: 'Yes, we provide transportation for both local and outstation corporate events. Whether it’s a day trip or a multi-day event, we’ve got reliable travel solutions ready.',
  },
  {
    question: 'How early should I book buses for a corporate event?',
    answer: 'To ensure availability and smooth planning, it’s best to book at least 5-7 days in advance. For large events or during peak seasons, even earlier bookings are recommended.',
  },
  {
    question: 'Are the drivers professional and punctual?',
    answer: 'Yes, our drivers are trained professionals who understand the importance of corporate schedules. They are punctual, courteous, and well-versed with city and outstation routes.',
  },
  {
    question: 'Do you offer branded or customized bus services for corporate branding?',
    answer: 'Yes, we can accommodate branding requests such as custom signage or company logos on buses, depending on availability and prior notice. Contact us for customization options.',
  },
  {
    question: 'What is the pricing structure for corporate event bus bookings?',
    answer: 'Pricing depends on the type of bus, duration, distance, and any custom requirements. We provide competitive, transparent quotes based on your event needs. Reach out for a tailored proposal.',
  },
  {
    question: 'Why choose Amruta Travels for corporate bus rentals?',
    answer: 'Amruta Travels is known for professional, reliable, and organized transportation services. With clean buses, trained drivers, and end-to-end coordination, we make sure your team travels safely and comfortably.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Ms. Priya Kulkarni',
    role: 'HR Manager, Pune Tech Solutions',
    text: 'Amruta Travels provided excellent transport services for our annual corporate seminar. Everything from route planning to on-time pickups was handled seamlessly. Highly professional team!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Rohit Joshi',
    role: 'Event Coordinator, Vertex Global',
    text: 'We booked multiple buses for our company’s team-building event and were impressed by the cleanliness of the vehicles and the punctuality of the drivers. Will definitely work with Amruta Travels again!',
    rating: 5,
  },
];





































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Buses For Corporate Events in Pune",
  "image": "https://bushireinpune.com/assets/images/bus-hire-for-corporate-events.jpg",
  "description": "Book corporate bus hire services in Pune with Amruta Travels. Choose from AC 25, 26, 32, 35, and 50-seater buses for office trips, corporate parties, outstation events, and daily staff transport. Affordable, comfortable, and punctual service tailored for corporate needs.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "14387"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3199",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-hire-for-corporate-events"
  }
};





    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Buses For Corporate Events in Pune | Staff & Office Transport | Amruta Travels</title>
  <meta 
    name="description" 
    content="Hire buses for corporate events, staff pick-up & drop, and office transport from Pune. Amruta Travels offers AC, affordable, and reliable bus services for the corporate sector. Choose from 25 to 50-seater options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/2.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busesforcorporateevent;